import { render, staticRenderFns } from "./MessageStatus.vue?vue&type=template&id=5deeddd8"
import script from "./MessageStatus.vue?vue&type=script&lang=js"
export * from "./MessageStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports